import { enrichCommunityPost, ICommunityPost } from './CommunityPost';
import { enrichThinLecture, IThinLecture } from './ThinLectures';
import { enrichThinProfile, IThinProfile } from './ThinProfile';
import { enrichUser, IUser } from './User';

// snake_case mirror of the datx `Notification` resource, served by the kitsu client.
// Backs the event header "bell" popover, which now carries both lecture and
// community activity notifications (GET /notifications).
export interface INotification {
  id: string;
  // The notification kind, e.g. 'lecture_chat_comment', 'community_post_liked',
  // 'community_post_new_comment', 'community_post_new_reply', 'community_comment_liked',
  // 'community_reply_liked'. NOTE: kitsu-core's deattribute copies the `type` attribute
  // onto the resource, overwriting the JSON:API resource type ('notifications') — so this
  // field holds the notification kind, not 'notifications'. Typed loosely for now.
  type: string;
  // The subject resource, e.g. 'Lecture', 'Comment', 'Reactions::ThumbsUp'.
  resource_type: string;
  resource_id?: string;
  read: boolean;
  created_at: string;
  // Per-row unread counter the backend attaches under the resource's own meta.
  meta?: { unread_count?: number };
  // Relationships (resolved by kitsu-core when included).
  // Lecture notifications carry `lecture`; community notifications carry
  // `community_post` + `actor_profile`.
  lecture?: IThinLecture;
  community_post?: ICommunityPost;
  actor_profile?: IThinProfile;
  user?: IUser;
  // Relationship linkage only ({ id, type }) — for reaction notifications
  // (community_comment_liked / community_reply_liked) this points at the liked
  // comment so the post page can scroll to it. Reactions carry the reaction id
  // in resource_id, not the comment id, so this is the only way to target it.
  comment?: { id: string; type?: string };
}

export function enrichNotification(notification: INotification): INotification {
  return {
    ...notification,
    lecture: notification.lecture ? enrichThinLecture(notification.lecture) : undefined,
    community_post: notification.community_post ? enrichCommunityPost(notification.community_post) : undefined,
    actor_profile: notification.actor_profile ? enrichThinProfile(notification.actor_profile) : undefined,
    user: notification.user ? enrichUser(notification.user) : undefined,
  };
}
